import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/shared/services';
import { NotifierService } from 'angular-notifier';
import { TenantGeneralService } from 'src/app/core/tenant-general.service';
import { MerchantService } from 'src/app/core/merchant.service';
import { UserService } from 'src/app/shared/services/user.service';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'app-login-main',
  templateUrl: './login-main.component.html',
  styleUrls: ['./login-main.component.scss'],
})
export class LoginMainComponent implements OnInit {
  private readonly notifier: NotifierService;
  hide: boolean = true;
  loginForm: FormGroup;
  merchant: string = '';
  tenant: string = '';
  public loading: boolean;
  @Output() setLoginValue = new EventEmitter<boolean>();
  @Output() setPassValue = new EventEmitter<boolean>();

  get loginFormControl() {
    return this.loginForm.controls;
  }

  get login(): any {
    const login = this.loginForm.value;
    return login;
  }

  isMobile: boolean;

  constructor(
    notifierService: NotifierService,
    private readonly merchantService: MerchantService,
    public tenantService: TenantGeneralService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly fb: FormBuilder,
    private readonly authService: AuthenticationService,
    private readonly userService: UserService
  ) {
    this.notifier = notifierService;
    this.loginForm = fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(100),
        ],
      ],
    });
  }

  ngOnInit(): void {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });
    this.merchant = this.merchantService.getLoginMerchant(this.tenant);
  }

  addHours(numOfHours, date = new Date()) {
    date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);

    return date.toISOString();
  }

  signIn() {
    this.loading = true;

    this.authService
      .authenticate(this.login)
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          if (res.id_token) {
            this.loading = false;
            let date = new Date();
            let currentTokenExpiration = this.addHours(1, date);
            localStorage.setItem('token-expiresAt', currentTokenExpiration);
            this.router.navigate([`${this.tenant}/home`]);
            firstValueFrom(this.userService.updateTuneTransaction(localStorage.getItem('transaction_id')));
            firstValueFrom(this.userService.updateTuneAffiliate(localStorage.getItem('affiliate_id')));
          this.authService.userData.partnerCode = this.tenant;
            this.authService.userData.key = res.id_token;
          }
        },
        () => {
          this.loading = false;
        }
      );
  }

  goToLogin() {
    this.setLoginValue.emit(false);
    this.setPassValue.emit(false);
  }

  goToForgotPass() {
    this.setLoginValue.emit(false);
    this.setPassValue.emit(true);

    this.router.navigateByUrl(
      `${this.tenant}/login/forgot-password?m=${this.merchant}`
    );
  }
}
